export class ExportStyles {
  constructor(v: Partial<ExportStyles> = {}) {

  }
}
